import { Injectable, signal } from '@angular/core';

export interface ConfirmOptions {
  title: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  /** Czerwony przycisk potwierdzenia — dla akcji destrukcyjnych. */
  danger?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ConfirmService {
  // Aktywne zapytanie (null = modal zamknięty).
  readonly request = signal<ConfirmOptions | null>(null);
  private resolver: ((value: boolean) => void) | null = null;

  /** Otwiera modal i czeka na decyzję. true = potwierdzono. */
  ask(opts: ConfirmOptions): Promise<boolean> {
    // Domknij ewentualne poprzednie zapytanie jako anulowane.
    this.resolver?.(false);
    this.request.set(opts);
    return new Promise<boolean>((resolve) => {
      this.resolver = resolve;
    });
  }

  resolve(value: boolean) {
    this.request.set(null);
    const r = this.resolver;
    this.resolver = null;
    r?.(value);
  }
}
